var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6602 15.4038C11.3786 16.3872 12.5454 16.3872 13.2638 15.4038L20.6208 5.33369C21.1495 4.60989 21.3047 3.53207 21.0174 2.588C20.73 1.64392 20.0632 1.03027 19.3161 1.03027L4.6022 1.03814C3.86076 1.03814 3.18829 1.65179 2.90091 2.59587C2.61353 3.53994 2.77446 4.61776 3.29749 5.34155L10.6544 15.4117L10.6602 15.4038Z",
    fill: "#BF96FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.e2af95cb20cb45aab9ebdb8f43bfd1b5.svg";
export { ForwardRef as ReactComponent };